import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Absolute Marine Equipment brand lockup — horizontal PNG artwork
 * containing both the triangle "A" mark and the wordmark in one asset.
 * Height is fluid across breakpoints; width scales via aspect-ratio.
 * Always links back to the barge home page ("/") so it works on any
 * route in the app (barge, hammer, privacy, sms-terms).
 */
export default function Logo() {
  return (
    <Link
      to="/"
      aria-label="Absolute Marine Equipment"
      className="inline-flex items-center group"
      data-testid="brand-logo-link"
    >
      <img
        src="/assets/logo_horizontal.png"
        alt="Absolute Marine Equipment"
        className="h-8 sm:h-9 lg:h-10 w-auto shrink-0 object-contain transition-transform duration-300 group-hover:scale-[1.03]"
      />
    </Link>
  );
}
